/**
 * Labstep
 *
 * @module components/Layout/LeftPane
 * @desc Layout component for left pane in index pages
 */

import { LayoutLinks } from 'labstep-web/components/Layout/Links';
import React from 'react';
import styles from './styles.module.scss';
import type { LayoutLeftPaneProps } from './types';

export const LayoutLeftPane: RFC<LayoutLeftPaneProps> = ({
  children,
  links,
}) => (
  <div data-testid="left-pane" className={styles.container}>
    {links && (
      <div className={styles.linksContainer}>
        <LayoutLinks links={links} inverted stretch noBottomMargin />
      </div>
    )}
    <div data-testid="left-pane-panes" className={styles.panes}>
      {children}
    </div>
  </div>
);
